/* ANDREA – Our Products accordion menu (2026-10-20, hover on desktop 2026-10-23) */
(function () {
  if (window.__navAccordion) return;
  window.__navAccordion = true;

  // desktop with a mouse: categories open on hover; touch devices keep tap-to-open
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var hoverTimer = null;
  var lastX = 0;

  document.addEventListener('mousemove', function (e) { lastX = e.clientX; }, { passive: true });

  // keep the flyout inside the window on short screens
  function fitPanel(item) {
    var panel = item.querySelector(':scope > .nav-acc__panel');
    if (!panel) return;
    panel.style.top = '';
    var r = panel.getBoundingClientRect();
    var over = r.bottom - (window.innerHeight - 12);
    if (over > 0) panel.style.top = (parseFloat(getComputedStyle(panel).top) - over) + 'px';
  }

  function isDesktopMenu(el) {
    return !!(el && el.closest && el.closest('.site-nav.style--classic'));
  }

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var t = item.querySelector('.nav-acc__toggle');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeSiblings(item) {
    var list = item.parentElement;
    if (!list) return;
    Array.prototype.forEach.call(list.children, function (sib) {
      if (sib !== item && sib.classList.contains('nav-acc') && sib.classList.contains('is-open')) setOpen(sib, false);
    });
  }

  function resizeMobileNav(mob) {
    // keep the drawer's panel height in sync while the accordion animates
    var start = performance.now();
    function step(now) {
      var sub = mob.querySelector('.has-submenu.opened > .submenu');
      if (sub) mob.style.height = sub.scrollHeight + 'px';
      if (now - start < 360) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function toggle(btn) {
    var item = btn.closest('.nav-acc');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    closeSiblings(item);
    setOpen(item, open);
    var mob = item.closest('mobile-navigation');
    if (mob) resizeMobileNav(mob);
  }

  function hoverMode(el) {
    return canHover.matches && isDesktopMenu(el);
  }

  // hover (desktop + mouse): open the category under the cursor after a short pause,
  // so the menu doesn't flicker when the cursor just passes over it
  document.addEventListener('mouseover', function (e) {
    if (!hoverMode(e.target)) return;
    var holder = e.target.closest('.submenu.has-acc .submenu-holder');
    if (!holder) return;
    var row = e.target.closest('.nav-acc');
    if (!row) {
      row = e.target.closest('li');
      while (row && row.parentElement !== holder) row = row.parentElement && row.parentElement.closest('li');
    }
    if (!row || row.parentElement !== holder) return;
    clearTimeout(hoverTimer);
    if (row.classList.contains('nav-acc')) {
      if (row.classList.contains('is-open')) return;
      var openRow = holder.querySelector(':scope > .nav-acc.is-open');
      // heading towards the open flyout? wait longer, so crossing another category diagonally doesn't switch
      var rtl = document.documentElement.dir === 'rtl';
      var towardsFlyout = openRow && (rtl ? e.clientX < lastX : e.clientX > lastX);
      hoverTimer = setTimeout(function () {
        closeSiblings(row);
        setOpen(row, true);
        fitPanel(row);
      }, openRow ? (towardsFlyout ? 320 : 160) : 90);
    } else {
      // cursor on a plain link (e.g. All products): close any open category
      hoverTimer = setTimeout(function () {
        holder.querySelectorAll(':scope > .nav-acc.is-open').forEach(function (it) { setOpen(it, false); });
      }, 200);
    }
  });

  // click / tap on a category: open its sub-categories instead of navigating
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nav-acc__toggle');
    if (!btn) return;
    e.preventDefault();
    if (hoverMode(btn)) {
      // with a mouse a click never closes the category the cursor is on
      clearTimeout(hoverTimer);
      var item = btn.closest('.nav-acc');
      closeSiblings(item);
      setOpen(item, true);
      fitPanel(item);
      return;
    }
    toggle(btn);
  });

  // keyboard: Enter / Space toggles (runs before the theme's own menu key handlers)
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('.nav-acc__toggle');
    if (!btn) return;
    if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      e.stopPropagation();
      toggle(btn);
    }
  }, true);

  // touch: stop the theme from closing the whole dropdown when a category is tapped
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest && e.target.closest('.style--classic .nav-acc')) {
      e.stopPropagation();
    }
  }, { capture: true, passive: true });

  // when the desktop dropdown closes, reset the open categories
  document.addEventListener('mouseout', function (e) {
    var menu = e.target.closest && e.target.closest('.style--classic .has-submenu');
    if (!menu || (e.relatedTarget && menu.contains(e.relatedTarget))) return;
    clearTimeout(hoverTimer);
    setTimeout(function () {
      if (menu.matches(':hover') || menu.classList.contains('focus')) return;
      menu.querySelectorAll('.nav-acc.is-open').forEach(function (item) { setOpen(item, false); });
    }, 250);
  });
})();
